/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.branches.internal

import features.branches.models.Business
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class BranchesServiceImpl : BranchesService {

    private val branchesRequest = BranchesRequest()

    override suspend fun getBusinessBranches(
        overrideHeaders : Map<String, String>?,
        businessId: String    ): Result<Business> {
        return branchesRequest.getBusinessBranches(
            overrideHeaders = overrideHeaders,
            businessId = businessId        ).toModel()
    }
}
